<template>
    <div>
        <div
            ref="wrapper"
            :class="{
                contentwrapper: true,
                expand: expanded
            }"
            :style="setStyle()"
        >
            <div v-html="finalContent" id="final-content" />
            <slot />
        </div>

        <a
            v-if="showSeeMore && !expanded"
            href="#"
            @click.prevent="expandContent"
        >
            {{ moreText }}
        </a>

        <a
            v-if="expanded && showSeeLess"
            href="#"
            @click.prevent="collapseContent"
        >
            See less
        </a>
    </div>
</template>

<script>
const ANCHOR_REGEX = /<a href=['"][^'"]+['"](?![^>]*target=['"]?_blank['"]?[^>]*>)/g;
// const URL_REGEX = /(https?:\/\/[^\s<]+)/g;
// const URL_REGEX = /(?<!=['"]?)(https?:\/\/[^\s<]+)/g;

export default {
    name: "html-content",
    props: {
        maxHeight: {
            type: Number, // in px
            required: false
        },
        maxWidth: {
            type: Number, // in px
            required: false
        },
        content: {
            type: String,
            required: true
        },
        expanded: {
            type: Boolean,
            default: () => false
        },
        isReplaceNewLine: {
            type: Boolean
        },
        moreText: {
            type: String,
            default: "Read more"
        },
        showSeeLess: {
            type: Boolean,
            default: true
        },
        checkForEntities: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showSeeMore: false
        };
    },
    mounted() {
        let self = this;

        this.$nextTick(() => {
            setTimeout(function () {
                if (self.$refs.wrapper) {
                    let { scrollHeight, clientHeight } = self.$refs.wrapper;

                    if (scrollHeight > clientHeight) {
                        self.showSeeMore = true;
                    }
                }
            }, 50);
        });
    },
    computed: {
        finalContent() {
            let str = this.content;

            if (this.checkForEntities && str) {
                str = this.decodeHtmlEntities(str);
            }
            if (this.isReplaceNewLine && str) {
                str = this.replaceNewLine(str);
            }

            return this.enhanceLink(str);
        }
    },
    methods: {
        setStyle() {
            let maxHeight = this.maxHeight
                ? `max-height:${this.maxHeight}px`
                : "";
            let maxWidth = this.maxWidth ? `max-width:${this.maxWidth}px` : "";
            let selectedStyle = `${maxHeight};${maxWidth}`;
            return selectedStyle;
        },
        replaceNewLine(content = "") {
            content = content.replace(/(?:\r\n|\r|\n)/g, "<br/>");
            return content;
        },
        expandContent() {
            this.$emit("onClickSeeMore");
        },
        collapseContent() {
            this.$emit("onClickSeeLess");
        },
        enhanceLink(inputStr) {
            // add target="_blank" to existing <a> tags that don't already have it
            let str = inputStr.replace(ANCHOR_REGEX, match => {
                return match + ' target="_blank"';
            });

            // convert non-anchor urls into clickable links with target="_blank" (ignore any existing anchor tag)
            // temporary disable:
            /* str = str.replace(URL_REGEX, (url, _, offset, fullStr) => {
                let insideHtmlAttribute = fullStr[offset - 1] === "=" || fullStr[offset - 1] === '"'; // prettier-ignore

                // check if the matched url is inside an html tag
                if (offset > 0 && insideHtmlAttribute) {
                    return url; // return the url unchanged
                }

                console.log(url);

                let displayUrl = url;
                let maxLength = 50;
                if (displayUrl.length > maxLength) {
                    displayUrl = displayUrl.substring(0, maxLength) + "...";
                }

                return `<a href="${url}" target="_blank" title="${url}">${displayUrl}</a>`;
            }); */

            return str;
        }
    }
};
</script>

<style scoped>
.contentwrapper {
    display: block;
    text-overflow: ellipsis;
    word-wrap: break-word;
    overflow: hidden;
    line-height: 1.8em;
    max-height: 12.6em; /* line-height * (n) lines */
}

.contentwrapper.expand {
    overflow: unset;
    max-height: unset !important;
}
</style>
